import React, {useRef, useEffect} from 'react'
import {Modal} from 'antd'
import {useHistory} from 'react-router'

interface Props {
  loginCardVisible: boolean
  setVisible: (visible: boolean) => void
}
const LoginCardCom: React.FC<Props> = ({loginCardVisible, setVisible}) => {
  const imageRef = useRef<HTMLImageElement | null>(null)

  const history = useHistory()
  useEffect(() => {
    if (loginCardVisible === true) {
      openLoginCard()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginCardVisible])
  const openLoginCard = () => {
    if (imageRef.current) {
      let loginCardImages = [
        '/images/login-card-first.png',
        '/images/login-card-second.png',
        '/images/login-card-third.png',
      ]
      let randomNum = Math.floor(Math.random() * loginCardImages.length)
      imageRef.current.src = process.env.PUBLIC_URL + loginCardImages[randomNum]
    }
  }

  const navigateToLogin = () => {
    history.push('/login')
  }

  const cancelToLogin = () => {
    setVisible(false)
  }
  return (
    <>
      <Modal
        width={466}
        visible={loginCardVisible}
        className="home-login-card"
        okText="去登录"
        cancelText="再想想"
        onCancel={cancelToLogin}
        onOk={navigateToLogin}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/login-card-first.png`}
          ref={imageRef}
          alt="login-card"
        />
      </Modal>
    </>
  )
}

export default LoginCardCom
